import SimpleInput from './input';

export default SimpleInput